/**
 * Clonedeep a class
 */
export default (value) => Object.assign(Object.create(Object.getPrototypeOf(value)), value)
